export default {
    ohilio_guard1: {
        attack: 0.15,
        health: 150,
        textShadow: '1px 1px 2px palevioletred, 0 0 25px lightpink, 0 0 5px pink',
        sigil: {
            shotgun_gun: 3,
            war_bandage: 3,
        },
        stats: {}
    },
    ohilio_guard2: {
        attack: 0.6125,
        health: 45,
        textShadow: '1px 1px 2px palevioletred, 0 0 25px lightpink, 0 0 5px pink',
        sigil: {
            rifle_gun: 3,
            war_grenade: 2,
        },
        stats: {}
    },
    ohilio: {
        attack: 0.01,
        health: 0.00000001,
        textShadow: '1px 1px 2px palevioletred, 0 0 25px lightpink, 0 0 5px pink',
        sigil: {
            ohilio_megagun: 1,
        },
        stats: {}
    },
    mina: {
        attack: 0.5,
        health: 87.5,
        textShadow: '1px 1px 2px palevioletred, 0 0 25px lightpink, 0 0 5px pink',
        sigil: {
            mina_charm: 1,
        },
        stats: {
            toxic_base: 0.03,
            execute_base: 0.2
        }
    },
    chriz1: {
        attack: 0.375,
        health: 42.5,
        textShadow: '1px 1px 2px blue',
        sigil: {
            chriz_magicMissile: 1,
            chriz_fireball: 1,
            chriz_iceBlast: 1,
            chriz_lightningStrike: 1,
            chriz_heal: 1,
        },
        stats: {
            magicConversion_base: 4,
            physicTaken_mult: 0.01,
            magicTaken_mult: 1.75,
        }
    },
    chriz2: {
        attack: 0.5,
        health: 50,
        textShadow: '1px 1px 2px red',
        sigil: {},
        stats: {
            critChance_base: 0.35,
            critMult_base: 3,
            physicTaken_mult: 1.75,
            magicTaken_mult: 0.01,
        }
    }
}
